import ContentSection from './contentSection';

const HARM_REDUCTION = [
  {
    title: "Learn about the impact of steroids on your body",
    description: "See our simulator below"
  },
  {
    title: "Discuss steroid use with a healthcare provider you trust",
    description: "See our guide for discussions with your doctor"
  },
  {
    title: "Decrease risk of infection when using steroids",
    description: "Use new needles each time and follow safe injection techniques"
  },
  {
    title: "Decrease risk of prolonged dependence",
    description: "Clomid, post-cycle therapy, etc."
  },
  {
    title: "Decrease risk of organ-specific damage",
    description: "Monitor bloodwork closely and avoid oral steroids to avoid liver damage"
  },
  {
    title: "Go low and stay low",
    description: "The more/longer people use steroids, the more likely they will have side effects and develop dependence on steroid use"
  }
];

const HarmReduction = (props) => {
  return (
    <section className="content-section">
      <h2>Harm reduction approaches</h2>
      <p>
        Many patients who are using steroids are not interested in stopping.
        All patients, regardless of their goals,
        can undergo medical interventions that optimize their health outcomes.
      </p>
      <p>
        <span className="highlight">The purpose of this site is neither to encourage steroid use nor to promote cessation.</span> Instead,
        we hope that people who do choose to use steroids can be as safe as possible and understand
        the risks involved in order to make informed decisions. This is called <b>harm reduction</b>.
      </p>
      <p>
        The National Harm Reduction Coalition <a href="https://harmreduction.org/about-us/principles-of-harm-reduction/">defines harm reduction</a> as:
        <blockquote>
          "a set of practical strategies and ideas aimed at reducing negative consequences
          associated with drug use. Harm Reduction is also a movement for social justice
          built on a belief in, and respect for, the rights of people who use drugs."
        </blockquote>
      </p>
      <p>
        In order to decrease the risks involved with steroid usage, we've listed a few harm reduction
        guidelines below.
      </p>
      <br/>
      <ContentSection data={HARM_REDUCTION.slice(0, 3)}/>
      <ContentSection data={HARM_REDUCTION.slice(3)}/>

      <div id="pregame" className="content-section-boxed">
        <p>
          <b>Want to understand how different performance enhancing substances and steroids impact the body? </b>
          The simulator below allows you to understand some of the risks and benefits of different types of usage.
          {props.patientSite
            ? " It also generates a list of questions to bring to your doctor."
            : " It also generates a list of questions to discuss with your patients."
          }
        </p>
        {props.patientSite && <p>
          <span className="highlight">This simulator is meant to inform you before seeing a physician, not to replace a physician altogether.</span>
        </p>}
      </div>
    </section>
  );
}

export default HarmReduction;